<template lang="pug">
.container.grid-lg
  .card.mt-2
    .card-header
      .text-bold Filtrar
    .card-body
      fieldset(:disabled="loading")
        form-filter(@submit="onFilter")
  v-map.mt-2.map-style(
    ref="mapRef",
    :center="municipioLocal",
    :zoom="12",
    @idle="onMapIdle"
  )
    v-marker(
      v-for="marker in report",
      @click="onClickMarker(marker)",
      :position="marker",
      :info-window="infoWindow(marker)",
      :key="marker.id",
      :options="options(marker)"
    )
    .map-overlay.flex-centered(v-if="loading")
      .loading.loading-lg
  .pull-right
    small Total: {{ Math.floor(totalRepost).toLocaleString("pt-BR") }} registros
</template>

<script>
import { deepClone } from "paliari-js-utils"
import FormFilter from "./components/Filter"
import toastErrors from "@/lib/errors/toastErrors"
import ordemServicos from "@/api/indicadores/ordemServicos"
import ApiInfoService from "@/lib/ApiInfoService"

export default {
  components: { FormFilter },
  data() {
    return {
      q: {},
      bounds: {},
      zoom: 0,
      loading: false,
      report: [],
      municipioLocal: ApiInfoService.getInfo().municipio_local,
    }
  },
  methods: {
    async fetchReport() {
      try {
        this.loading = true
        const { q, bounds } = this
        this.report = await ordemServicos.mapaPontos(this.zoom, {
          q,
          bounds,
        })
      } catch (e) {
        toastErrors(e)
      } finally {
        this.loading = false
      }
    },
    options(marker) {
      const options = {}

      options.icon = require("@/assets/pin_red.png")

      if (marker.q > 1) {
        options.label = {
          text: String(marker.q),
          color: "#fff",
          fontSize: "11px",
          fontWeight: "bold",
        }
        options.icon = require("@/assets/group-marker.png")
      }
      return options
    },
    infoWindow(marker) {
      if (marker.q > 1) return null
      return `
          <div style="color: #666">
            Serviço <b>${marker.numero}/${marker.ano}</b>
          </div>
          <div class="mt-2">
            <small>
              <a style="box-shadow: none;" href="/#/app/osm/servicos/${marker.id}" target="_blank">
                <span class="fa fa-eye" />
                &nbsp;Ver serviço
              </a>
            </small>
          </div>
        `
    },
    onClickMarker(marker) {
      if (!this.$refs.mapRef || !this.$refs.mapRef.map) return
      if (marker.q > 1) {
        this.$refs.mapRef.map.setZoom(this.$refs.mapRef.map.getZoom() + 1)
        this.$refs.mapRef.map.panTo(marker)
      }
    },
    onMapIdle() {
      this.bounds = this.$refs.mapRef
        ? this.$refs.mapRef.map.getBounds().toJSON()
        : null
      this.zoom = this.$refs.mapRef ? this.$refs.mapRef.map.getZoom() : 0

      this.fetchReport()
    },
    onFilter(q) {
      this.q = deepClone(q)
      this.fetchReport()
    },
  },
  computed: {
    totalRepost() {
      let count = 0
      if (this.report && this.report.length > 0) {
        this.report.map((item) => {
          count += item.q
        })
      }

      return count
    },
  },
}
</script>

<style lang="stylus" scoped>
.map-style {
  height: calc(100vh - 280px);
  border-radius: 10px;
  position: relative;

  .map-overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(255, 255, 255, 0.8);
  }
}
</style>
